import React,{useState} from "react";
import {getVector} from "../../services/functions.js";
//const abraStr = abraStr || {};
import Pop from "../../components/pop/pop.jsx";

const types =   [
    {
        text:abraStr.telescopicCrown,
        icon:"crown"
    },
    {
        text:abraStr.telescopicBridge,
        icon:"bridge"
    },
    {
        text:abraStr.telescopicOverdenture,
        icon:"dental"
    }
];

const TypePanel = (props)=>{

    const {
        curType,
        changeType,
        setAppState,
        canChange,
        overDentureType,
        setOverDentureType,
        getPositionsWithoutBridges,
        setBridgeProgress,
        setBridgeState
    } = props;

    const typeChanged = (type)=>{
        if(!canChange) return;
        changeType(type);
        setAppState("choose-teeth");
    }



    return(
        <div
            className={`abra-types panel ${canChange? "can-change" : "cannot-change"} ${curType ===  null? "open" : "locked"}`}
        >
            <h4>{abraStr.type}</h4>
            <div className='items flex'>
                {types.map((item,index)=>{
                    const isOverDentureWithoutSubType = curType === 2 && index === 2 && !overDentureType;
                    return(
                        <div
                            key={index}
                            onClick={()=>{typeChanged(index)}}
                            className={`${(curType === index)? "on" : ""} ${isOverDentureWithoutSubType? "process" : ""}`}
                        >
                            <img src={getVector(item.icon)}/>
                            <p>{item.text}</p>
                            { isOverDentureWithoutSubType &&
                            <Pop
                                popType="overdenture-type"
                                getPositionsWithoutBridges={getPositionsWithoutBridges}
                                popClicked={(type)=>{
                                    if(type === "whole"){
                                        setBridgeProgress({type:"jaw-type"})
                                    }else{
                                        setBridgeProgress({type:"partial-init"})
                                    }
                                    setOverDentureType(type);
                                }}
                            />}
                        </div>
                    )
                }

                )}
            </div>
        </div>
    );
}

export default TypePanel;